module.exports = __webpack_public_path__ + "img/tools_1.8a632afb.png";